import styles from './Loader.module.scss';

const Loader = ({ height }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: height ? height : '5vh', width: '100%' }}>
            <img className={styles.img} src="/logo.svg" alt="" width={'80px'} />
        </div>
    );
};

export default Loader;